import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const STitledStepsGuide = styled.section`
  display: grid;

  grid-gap: 1rem;
  grid-template:
    'title button'
    'steps steps';

  @media ${BREAKPOINTS.MD.max} {
    grid-template:
      'title'
      'steps'
      'button';
  }
`

export const SAreaTitle = styled.div`
  grid-area: title;
`

export const SAreaButton = styled.div`
  grid-area: button;

  & button,
  a {
    width: 100%;
  }

  @media ${BREAKPOINTS.MD.max} {
    padding-top: 1rem;
  }

  @media ${BREAKPOINTS.MD.min} {
    display: flex;

    & button,
    a {
      width: min-content;
      margin-left: auto;
    }
  }
`

export const SAreaSteps = styled.div`
  grid-area: steps;
`
